import React from 'react'
import { components, GroupTypeBase, IndicatorProps } from 'react-select'
import styled from 'styled-components'
import { OptionType } from '../../types/utilities'

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 0px;
    padding-bottom: 0px;
    margin-top: 5px;
`

export const Asterisk = styled.span`
    color: ${({ theme }) => theme['red-700']};
    font-size: 13px;
    margin-left: 5px;
`

export const Title = styled.text`
    margin-left: 8px;
    margin-top: 0px;
    padding-top: 0px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-800']};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
`

export const DivIcon = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    overflow: visible;
    cursor: pointer;
    &:hover {
        .emailInputRecipient_tooltip {
            display: flex;
            visibility: visible;
        }
    }
`

export const BottomText = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 5px;
`
export const Text = styled.label`
    font-family: ${({ theme }) => theme['font-regular']};
    color: ${({ theme }) => theme['gray-700']};
    font-size: 12px;
    line-height: 16px;
    margin-left: 5px;
`

export const IconBottom = styled.i`
    font-family: 'Font Awesome 5 Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 95%;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-700']};
    margin-left: 6px;
`

export const IconHeader = styled.i`
    font-family: 'Font Awesome 5 Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 95%;
    line-height: 16px;
    color: ${({ theme }) => theme['blue-500']};
    margin-left: 6px;
`

export const Placeholder = (props: IndicatorProps<OptionType, boolean, GroupTypeBase<OptionType>>): JSX.Element => {
    return <components.Placeholder {...props} />
}

export const DropdownIndicator = (
    props: IndicatorProps<OptionType, boolean, GroupTypeBase<OptionType>>
): JSX.Element => {
    return (
        components.DropdownIndicator && <components.DropdownIndicator {...props}>{null}</components.DropdownIndicator>
    )
}
